import React, { useEffect, useState } from "react";

const SECTIONS = [
  { id: "home", label: "Hero" },
  { id: "thesis", label: "Thesis" },
  { id: "mentor-section", label: "Platform" },
  { id: "venture-studio-section", label: "Journey" },
  { id: "portfolio", label: "Portfolio" },
  { id: "next-chapter-section", label: "What's Next" },
  { id: "returns-lab-section", label: "Returns Lab" },
  { id: "team", label: "Team" },
  { id: "why-partner-section", label: "Tracks" },
  { id: "contact", label: "Contact" },
];

export default function JourneyRail() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const mid = window.scrollY + window.innerHeight * 0.4;
      let current = 0;
      SECTIONS.forEach((s, i) => {
        const el =
          document.getElementById(s.id) ||
          document.querySelector(`[data-testid="${s.id}"]`);
        if (el) {
          const top = el.getBoundingClientRect().top + window.scrollY;
          if (top <= mid) current = i;
        }
      });
      setActive(current);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (s) => {
    const el =
      document.getElementById(s.id) ||
      document.querySelector(`[data-testid="${s.id}"]`);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      aria-label="Page sections"
      data-testid="journey-rail"
      className="hidden xl:flex fixed right-6 top-1/2 -translate-y-1/2 z-40 flex-col gap-3 pointer-events-auto"
    >
      {SECTIONS.map((s, i) => {
        const isActive = active === i;
        return (
          <button
            key={s.id}
            onClick={() => goTo(s)}
            className="group relative flex items-center justify-end gap-3"
            aria-label={s.label}
          >
            <span
              className={`text-[10px] uppercase tracking-[0.28em] font-semibold transition-all whitespace-nowrap ${
                isActive
                  ? "text-[#14401F] opacity-100 translate-x-0"
                  : "text-[#14401F]/55 opacity-0 -translate-x-1 group-hover:opacity-90 group-hover:translate-x-0"
              }`}
            >
              {String(i + 1).padStart(2, "0")} · {s.label}
            </span>
            <span
              className={`block rounded-full transition-all ${
                isActive
                  ? "h-2 w-8 bg-[#14401F]"
                  : "h-1.5 w-1.5 bg-[#14401F]/30 group-hover:bg-[#14401F]/70"
              }`}
            />
          </button>
        );
      })}
    </nav>
  );
}
